import { useEffect, useMemo, useState } from "react";
import { DataMapping, useGetVendorsQuery, useLazyGetDataMappingsQuery } from "../api/dataMapping/dataMappingApi";

/**
 * Search for some SKUs. Minimum 3 characters for render performance.
 * @param search Search query (title, internal SKU)
 */
export default function useGetSkus(search?: string) {
  const { data: vData, isFetching: vIsFetching } = useGetVendorsQuery();
  const [getDm] = useLazyGetDataMappingsQuery();

  // Includes client-side search
  const [dIsFetching, setDIsFetching] = useState(true);
  const [data, setData] = useState<DataMapping[]>([]);
  const filteredData = useMemo(() => {
    // if (search === undefined /* || search.length < 0 */) {
    //   return [];
    // }
    if (search === undefined) {
      return data;
    }

    setDIsFetching(true);
    const sData = data.filter(x =>
      x.ItemDetails?.Title?.toLowerCase().includes(search.toLowerCase())
      || x.InternalSku.toLowerCase().includes(search.toLowerCase())
    );
    setDIsFetching(false);
    return sData;
  }, [data, search]);

  useEffect(() => {
    if (!vData || !getDm) {
      return;
    }
    setDIsFetching(true);
    async function getAllDataAsync() {
      const newData = [];
      for (const v of vData!) {
        let after = undefined;
        do {
          const res = await getDm({ vendorId: v, after }).unwrap();
          newData.push(...res.Items);
          after = res.LastEvaluatedKey?.Id;
        } while (after !== undefined);
      }
      setData(newData);
      setDIsFetching(false);
    }
    getAllDataAsync();
  }, [vData, getDm]);

  const isFetching = dIsFetching || vIsFetching;

  return { data: filteredData, isFetching };
}